module.exports = __webpack_public_path__ + "static/media/MC2@2x.e2a7d362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/MC/MC2@2x.png
// module id = 693
// module chunks = 0